import Implant from '../../entities/Implant/ui/Implant';
import ImplantPrice from '../../entities/Price/ImplantPrice/ui/ImplantPrice';
import Surgery from '../../entities/Surgery/ui/Surgery';
import Footer from '../../widgets/Footer/ui/FooterContact/Footer';
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo';
import HeaderImplant from '../../widgets/HeaderImplant/ui/HeaderImplant';
import styles from './ImplantPage.module.scss';

export const ImplantPage = () => {
    return(
        <div className={styles.implant}>
            <HeaderImplant/>
            <Surgery/>
            <ImplantPrice/>
            <Implant/>
            <Footer/> 
            <FooterInfo/>
        </div>
    )
}